var AccountModificationValidate = $.extend({/* AccountModificationValidate */}, BaseComponent, {

	componentSelector: '#form-account-modification',

	init: function() {
		$(this.componentSelector).each(this.binding.bind(this));
	},

	binding: function(index, element) {

		$(element).validate({
			rules: {
				'iban-old-entity-1': { required: true },
				'iban-old-entity-2': { required: true },
				'iban-old-ccc-1': { required: true },
				'iban-old-ccc-2': { required: true },
				'iban-old-ccc-3': { required: true },
				'iban-old-ccc-4': { required: true },
				'iban-new-entity-1': { required: true },
				'iban-new-entity-2': { required: true },
				'iban-new-ccc-1': { required: true },
				'iban-new-ccc-2': { required: true },
				'iban-new-ccc-3': { required: true },
				'iban-new-ccc-4': { required: true }
			},
			groups: {
				accOld: 'iban-old-entity-1 iban-old-entity-2 iban-old-ccc-1 iban-old-ccc-2 iban-old-ccc-3 iban-old-ccc-4',
				accNew: 'iban-new-entity-1 iban-new-entity-2 iban-new-ccc-1 iban-new-ccc-2 iban-new-ccc-3 iban-new-ccc-4'
			},
			submitHandler: function(form) {
				form.submit();
			},
            errorPlacement: function (error, element) {
				error.insertAfter($(element).parents('.iban-input-container').find('.iban-input-col:last-child'));
            }
		});

		$(element).find('#form-acc-modification-submit').click((function(event) {
			event.preventDefault();
			$(element).submit();
		}).bind(this));
	}
})